module.exports = __webpack_public_path__ + "img/todos.6e35c01e.svg";